module.exports = __webpack_public_path__ + "assets/e7273c74c33933640d91e99ab09a93f0.png";